module.exports = __webpack_public_path__ + "img/link_icon_0.acbe185.png";